import React, { useMemo } from "react";
import { useState, useEffect } from "react";
import styles from "./RequirementsPage.module.css";
import { CpnwContainer } from "hooks/useCpnw";
import { HeaderSection, LinkItem, Modal, Button } from "@cpnw/ui";
import RequirementTable from "components/RequirementTable";
import { AdminContainer } from "hooks/useAdmin";
import { format, parseISO } from "date-fns";
import { StaticRoutes } from "pages/routes";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { RequirementContainer } from "hooks/useRequirement";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { AccountContainer } from "hooks/useAccount";
import environment from "environment";
import { CanPermissions } from "pages/enums";

export default function RequirementsPage() {
  const history = useHistory();
  const {
    adminRequirements,
    refetchAdminRequirements,
    requirementSelectboxValuesData,
    refetchRequirementSelectboxValues,
    setRequirement,
    deleteRequirement,
  } = RequirementContainer.useContainer();

  const [isLoading, setIsLoading] = useState(true);

  const { userRoles, hasCanPermissions } = AccountContainer.useContainer();

  // Check if user has the required roles
  const hasRequiredRoles = useMemo(() => {
    if (!userRoles) return false;
    return userRoles.some((role) =>
      ["EDUCATION", "HEALTHCARE", "CPNW-ADMIN", "CPNW-REVIEWER", "FACULTY"].includes(
        role.toUpperCase()
      )
    );
  }, [userRoles]);


  useEffect(() => {
    if (!hasRequiredRoles || !hasCanPermissions(CanPermissions.CanCoordinate)) {
      window.location.href = environment.homeUrl;
      return;
    }
  }, [hasRequiredRoles]);

  // API Call on mount

  useEffect(async () => {
    async function loadData() {
      setIsLoading(true);
      setRequirement(null);

      var requests = [];
      if (!requirementSelectboxValuesData) {
        requests = [refetchRequirementSelectboxValues()];
      }

      if (!adminRequirements) {
        requests.push(refetchAdminRequirements());
      }

      await Promise.all(requests);

      setIsLoading(false);
    }
    loadData();
  }, [adminRequirements, requirementSelectboxValuesData]);

  const data = useMemo(() => {
    if (
      adminRequirements &&
      adminRequirements.data &&
      requirementSelectboxValuesData
    ) {
      return adminRequirements.data.flatMap((a) => {
        const category = requirementSelectboxValuesData.Categories.find(
          (rc) => rc.Id == a.CategoryId
        );
        return {
          id: a.Id,
          name: a.Name,
          type: a.CategoryName,
          freq: a.FrequencyName,
          reqBy: requirementSelectboxValuesData.Facilities.filter((rf) =>
            a.FacilityIds.includes(rf.Id)
          )
            .map((rf) => rf.Name)
            .join(", "),
          reqFor: requirementSelectboxValuesData.Disciplines.filter((rd) =>
            a.DisciplineIds.includes(rd.Id)
          )
            .map((rf) => rf.Name)
            .join(", "),
          created: format(parseISO(a.CreatedOn), "MM/dd/yyyy"),
          retired: false,
          status: requirementSelectboxValuesData.Statuses.find(
            (rsd) => rsd.Id == a.StatusId
          ).Name,
          canEditTemplate: category?.CanEditTemplate || false,
        };
      });
    }
    return [];
  }, [adminRequirements, requirementSelectboxValuesData]);

  const [idToDelete, setIdToDelete] = useState(0);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const onEditRequirement = (id, { clearCategory = false } = {}) => {
    const existingRequirement = adminRequirements?.data?.find(
      (item) => item.Id == id
    );

    if (!existingRequirement) return;

    const editableRequirement = JSON.parse(
      JSON.stringify(existingRequirement)
    );

    if (clearCategory) {
      editableRequirement.CategoryId = null;
      editableRequirement.CategoryName = "";
    }

    setRequirement(editableRequirement);
    history.push(StaticRoutes.RequirementForm);
  };

  const onDeleteRequirement = async (id) => {
    console.log("onDeleteRequirement", id);
    setIdToDelete(id);
    setIsDeleteModalOpen(true);
  };


  return (
    <section>
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={() => {
          setIsDeleteModalOpen(false);
        }}
        className={classNames([])}
      >
        <div className={styles.warningTitle}>
          <FontAwesomeIcon icon={faWarning}></FontAwesomeIcon> This action
          cannot be reverted!
        </div>
        <div className={styles.center}>
          Do you want to delete this item '
          {data.find((a) => a.id == idToDelete)?.name}'?
        </div>
        <div className={classNames(styles.center, styles.warningButtons)}>
          <Button
            text={"YES"}
            type={"submit"}
            className={styles.customButton}
            onClick={async (ev) => {
              setIsDeleteModalOpen(false);
              setIdToDelete(0);
              setIsLoading(true);

              await deleteRequirement(idToDelete);
              await refetchAdminRequirements();

              setIsLoading(false);
            }}
          />
          <Button
            text={"NO"}
            type={"cancel"}
            className={styles.customButton}
            onClick={() => {
              setIdToDelete(0);
              setIsDeleteModalOpen(false);
            }}
          />
        </div>
      </Modal>
      <RequirementTable
        items={data || []}
        key={"1"}
        onAddRequirement={() => {
          setRequirement(null);
          history.push(StaticRoutes.RequirementForm);
        }}
        onEditRequirement={onEditRequirement}
        // onEditRequirement={(id) => {
        //   setRequirement(
        //     JSON.parse(
        //       JSON.stringify(adminRequirements.data.find((a) => a.Id == id))
        //     )
        //   );
        //   history.push(StaticRoutes.RequirementForm);
        // }}
        onDeleteRequirement={onDeleteRequirement}
        isLoading={isLoading}
      />
    </section>
  );
}
